import { Panel } from 'components/atoms/collapse';
import { withAccess } from 'hooks/rbac/withAccess';

export const RbacPanel = withAccess(Panel);
